import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
    footer: {
        flex: '0 0 auto',
        width: '100%',
        boxSizing: 'border-box',
        background: '#fff',
        borderTop: '1px solid #eef1f3',
        padding: '16px 24px',
        textAlign: 'center',
    },
    legal: {
        margin: 0,
        color: '#666',
        fontSize: '13px',
        lineHeight: 1.7,
        '& a': {
            color: '#0BADEC',
            textDecoration: 'none',
        },
    },
});

function Footer({ classes }) {
    const footer = (typeof window !== 'undefined' && window.Params && window.Params.site_footer) || '';
    const fallback =
        '&copy; 2018-2026 Иванов И.И. | ИНН 123456789012 НПД | <a href="mailto:">e-mail</a> | ' +
        '<a href="/privacy">Политика конфиденциальности</a> | ' +
        '<a href="/public-offer">Публичная оферта</a> | ' +
        '<a href="/personal">Согласие на обработку персональных данных</a>';
    return (
        <footer className={classes.footer}>
            <div className={classes.legal} dangerouslySetInnerHTML={{ __html: footer || fallback }} />
        </footer>
    );
}

export default withStyles(styles)(Footer);
